<!-- main toolbar -->
<lms-toolbar [options]="toolbarConfig">
  <ng-content select="[licenses-actions]"></ng-content>
</lms-toolbar>

<div class="gl-table__container">
  <!-- secondary toolbar -->
  <div *ngIf="selectable && isAnySelected">
    <div class="lms-toolbar__secondary" [ngClass]="{ _hidden: !isAnySelected }" tools-actions>
      <div class="list-counter">
        <span>
          {{ isHeaderSelectedAll ? dataSource.total - excludedLicenses.size : selectedLicenses.length }}
          {{ (selectedLicenses.length === 1 ? 'students.bulk.selectedSingle' : 'students.bulk.selected') | translate }}
        </span>
        <a
          (click)="setSelectAll(true)"
          *ngIf="!isHeaderSelectedAll"
          title="{{ 'students.bulk.selectAll' | translate : { total: dataSource.total } }}"
          >{{ 'students.bulk.selectAll' | translate : { total: dataSource.total } }}
        </a>
      </div>
      <div class="actions">
        <!-- injected bulk actions -->
        <ng-content select="[licenses-bulk-actions]"></ng-content>

        <div class="border-left padding-left margin-left-8">
          <gl-button
            color-secondary
            small
            [text]="'actions.cancelSelection' | translate"
            (onClick)="setSelectAll(false)"
          >
          </gl-button>
        </div>
      </div>
    </div>
  </div>

  <!-- table -->
  <gl-table
    #licensesTable
    [id]="listId"
    [dataSource]="dataSource"
    data-testid="licensesTable"
    [placeholder]="'actions.noResultTable' | translate"
    [attr.disableHeaderSelector]="isHeaderSelectedAll ? true : null"
    [attr.selectable]="selectable ? true : null"
    paginator
    scroll
    (onSelectionChanged)="onSelectionChanged($event.detail)"
    (onRowSelectionChanged)="onRowSelectionChanged($event.detail)"
    (onFiltersChanged)="onFiltersChanged()"
    (onDatasourceUpdate)="onDatasourceUpdate()"
  >
  </gl-table>
</div>
